import { config } from '../../../../config/config';
import { HubEvent } from '../../../models/hub/hub.event';
import { DefaultCategoryImageWebSide } from './default.category.image.web.side';
import { eventfulCategoriesWebSide } from './eventful.categories.web.side';

export class DefaultImageWebSideService {
    private static path = config.defaultImageDirectory;

    public static getDefaultImageByKeyword(event: HubEvent): HubEvent {
        if (!event.socialName || event.socialName !== 'eventful') {
            return event;
        }
        if (!event.cover || !event.cover.source) {
            event.cover = {source: null, isDefault: true};
            let categories = event.category.split(', ');
            let eventCategory = null;
            let category = eventfulCategoriesWebSide.category.first(x => x.name.toLowerCase() === categories[0].toLowerCase());
            if (!category) {
                return event;
            }

            eventCategory = category.id;
            let image: string;
            let result = DefaultCategoryImageWebSide.categories.find(x => {
                return x.category.name.toLowerCase() === eventCategory.toLowerCase();
            });
            if (result && result.category['keywords'].length > 0) {
                for (let keyword of result.category.keywords) {
                    if (keyword.keyword !== 'General' && (event.title.toLowerCase().indexOf(keyword.keyword.toLowerCase()) >= 0 || (event.description && event.description.toLowerCase().indexOf(keyword.keyword.toLowerCase()) >= 0))) {
                        image = keyword.defaultImage[keyword.index];
                        keyword.index < keyword.defaultImage.length - 1 ? keyword.index++ : keyword.index = 0;
                    }
                }
                if (!image) {
                    let generalImage = result.category['keywords'].find(x => {
                        return x.keyword === 'General';
                    });
                    if (generalImage && generalImage.defaultImage && generalImage.defaultImage.length > 0) {
                        image = generalImage.defaultImage[generalImage.index];
                        if (generalImage.index < generalImage.defaultImage.length - 1) {
                            generalImage.index++;
                        } else {
                            generalImage.index = 0;
                        }
                    } else {
                        event.cover.source = null;
                        return event;
                    }
                }
                event.cover.source = DefaultImageWebSideService.path + image;
                event.cover.isDefault = true;
                return event;
            }
            return event;
        }
        return event;
    }
}


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/services/default.images/default.image.web.side.service.ts